import { ConstantsService } from "./constants.service";

export function appInitializer(constantsService: ConstantsService) {
  return () => constantsService.waitForConstants();
}
